import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-shuffle",
  "use": "foquz-icon-shuffle-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol viewBox=\"0 0 12 10\" fill=\"none\" id=\"foquz-icon-shuffle\"><path d=\"M9.5 4L11 2.5m0 0L9.5 1M11 2.5H7l-3 5H1M9.5 6L11 7.5m0 0L9.5 9M11 7.5H7l-3-5H1\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol